module.exports = __webpack_public_path__ + "static/media/PremierGuaranteeLogo.cbcb4617.svg";